@if (isSmall) {
  <div class="c__review-header">
    @if (icon) {
      <sd-icon [name]="icon" [size]="iconSize.xl" />
    }
    <div class="c__review-meta">
      @if (reviewContent?.author) {
        <p class="is-medium is-text-dark">
          {{ reviewContent.author }}
        </p>
      }
      @if (reviewContent?.creationDate) {
        <p class="is-caption">
          {{ reviewContent.creationDate }}
        </p>
      }
    </div>
  </div>
  @if (reviewContent.rating) {
    <sd-rating
      [labelTitle]="'recipes.comments.ratingA11y' | translate : {
        recipe: reviewContent.recipeTitle,
        author: reviewContent.author
      }"
      [ratings]="reviewContent.rating"
      [readonly]="true"
      [showAverageRatingsLabel]="true"
      [showNumberOfReviews]="false"
    />
  }
  <sd-html innerClass="c__content is-wysiwyg" [html]="reviewContent.content" />
}

@if (!isSmall) {
  @if (reviewContent?.rating) {
    <sd-rating
      [labelTitle]="'recipes.comments.ratingA11y' | translate : {
        recipe: reviewContent?.recipeTitle,
        author: reviewContent?.author
      }"
      [ratings]="reviewContent?.rating"
      [readonly]="true"
      [showAverageRatingsLabel]="true"
      [showNumberOfReviews]="false"
    />
  }
  @if (reviewContent?.content) {
    <sd-html innerClass="c__content is-wysiwyg" [html]="reviewContent?.content" />
  }
  @if (reviewContent?.author) {
    <p class="is-caption c__author">
      {{ "ratings.reviewDetails" | translate: {author: reviewContent?.author, creationDate: reviewContent?.creationDate, purchasedDate: reviewContent?.purchasedDate} }}
    </p>
  }
  <form class="c__useful-form">
    {{ "ratings.useful.label" | translate}}
    <span class="c__vote is-positive">
      @if (!reviewContent?.vote?.positive?.voted) {
        <button
          type="button"
          class="is-reset is-link"
          (click)="voteClick(true)"
        >
          {{ "ratings.useful.yes" | translate}}
          @if (reviewContent?.vote?.positive?.value) {
            <span>({{reviewContent?.vote?.positive?.value}})</span>
          }
        </button>
      }
      @if (reviewContent?.vote?.positive?.voted) {
        <sd-tag
          [isButton]="true"
          [tagData]="{icon: 'icon-cross', iconPos: positionEnum.right, theme: brandThemesEnum.brand, ariaLabel: ('ratings.useful.yes' | translate) + ': ' + ('ratings.a11y.clearVoteAriaLabel' | translate)}"
          (tagClicked)="cancelVote(true)"
        >
          {{'ratings.useful.yes' | translate}} : {{reviewContent?.vote?.positive?.value}}
        </sd-tag>
      }
    </span>
    <span class="c__vote is-negative">
      @if (!reviewContent?.vote?.negative?.voted) {
        <button type="button" class="is-reset is-link" (click)="voteClick(false)">
          {{ "ratings.useful.no" | translate}}
          @if (reviewContent?.vote?.negative?.value) {
            <span>({{reviewContent?.vote?.negative?.value}})</span>
          }
        </button>
      }
      @if (reviewContent?.vote?.negative?.voted) {
        <sd-tag
          [isButton]="true"
          [tagData]="{icon: 'icon-cross', iconPos: positionEnum.right, theme: brandThemesEnum.brand, ariaLabel: ('ratings.useful.no' | translate) + ': ' + ('ratings.a11y.clearVoteAriaLabel' | translate)}"
          (tagClicked)="cancelVote(true)"
        >
          {{'ratings.useful.no' | translate}} : {{reviewContent?.vote?.negative?.value}}
        </sd-tag>
      }
    </span>
    @if (reviewContent?.avfFeedback) {
      <span class="c__vote">
        <p
          class="c__vote-message"
          [class.is-success]="reviewContent?.success"
          [class.is-error]="!reviewContent?.success"
        >
          {{reviewContent?.avfFeedback}}
        </p>
      </span>
    }
  </form>
}
